export function getServerTimestamp() {
  return Promise.resolve(Date.now())
}
